import O365Login from 'o365/containers/Login'
import O365Auth from 'o365/containers/Account'

export const RouteConfig = [
  {
    path: '/o365/login',
    component: O365Login
  },
  {
    path: '/o365/auth',
    component: O365Auth
  }
]